<div class="toast-container" aria-live="polite" aria-relevant="additions">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast-item"
      [class]="toast.type"
      [class.toast-actionable]="toast.actionRoute"
      role="alert"
      (click)="onToastClick(toast, $event)"
    >
      <div class="toast-icon" aria-hidden="true">
        <span class="toast-icon__badge">
          @switch (toast.type) {
            @case ('success') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            }
            @case ('error') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            }
            @case ('warning') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            }
            @case ('info') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            }
          }
        </span>
      </div>

      <div class="toast-body">
        <h4 class="toast-title">{{ toast.title }}</h4>
        @if (toast.message) {
          <p class="toast-message">{{ toast.message }}</p>
        }
      </div>

      <button
        type="button"
        class="toast-close"
        aria-label="Dismiss notification"
        (click)="remove(toast.id, $event)"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      @if (toast.duration > 0) {
        <div class="toast-progress" aria-hidden="true">
          <div class="progress-bar" [style.animation-duration.ms]="toast.duration"></div>
        </div>
      }
    </div>
  }
</div>
